import React from 'react';
export const ExampleComponent: React.FC = () => {
  return <div>Hola mundo component</div>;
};
